import React from "react";
import { Link } from "react-router-dom";

import NotFound from "../../assets/notfound404.svg";
import LayoutBlog from "../layouts/LayoutBlog";

const NotFound404 = () => {
	return (
		<LayoutBlog dontFooter={true}>
			<main className=" notfound main__container">
				<div className="notfound__container">
					<img src={NotFound} alt="" />
					<div className="notfound__box-info">
						<h1>404</h1>
						<h2>UH OH! Estás perdido!.</h2>
						<p>
							La página que estás buscando no existe. Como llegaste aquí es un misterio. Pero puedes presionar el
							botón de abajo para regresar a la página principal
							{/* The page you are looking for does not exist. How you got */}
							{/* here is a mystery. But you can click the button below to go back to the homepage. */}
						</p>
						<Link className="btn outline green" to="/">
							HOME
						</Link>
					</div>
				</div>
			</main>
		</LayoutBlog>
	);
};

export default NotFound404;
